module.exports = "<ui-switch (change)=\"onChange.emit($event)\" [checked]=\"value\" size=\"small\" defaultBgColor=\"#bfcbd9\" [disabled]=\"disable\"></ui-switch>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/atoms/toggle/toggle.component.html
// module id = ./src/app/shared/atoms/toggle/toggle.component.html
// module chunks = main